const defaultState = () => {
  return {
    auth0Client: null,
  };
};

export const state = defaultState;

export const mutations = {
  ['setAuth']: (state, data) => {
    state.auth0Client = data;
  },
};

export const actions = {
  ['setAuth']({ commit }, data) {
    commit('setAuth', data);
  },
  async ['isAuthenticated']({ state }) {
    try {
      await state.auth0Client.getAccessTokenSilently();
      return true;
    } catch {
      return false;
    }
  },
};

export const getters = {
  ['getAuth']: (state) => state.auth0Client,
};

export default {
  namespaced: true, // Important for namespacing module
  state,
  mutations,
  actions,
  getters,
};
